import { useState } from "react";
import type { UserSessionView } from "../../shared/models";
import { apiRequest } from "../lib/api";

interface LoginCodePageProps {
  onLogin: (user: UserSessionView) => Promise<void> | void;
  onBackToPassword: () => void;
}

export function LoginCodePage({ onLogin, onBackToPassword }: LoginCodePageProps) {
  const [form, setForm] = useState({ email: "", code: "" });
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function requestCode() {
    setError(null);
    try {
      const response = await apiRequest<{ message: string }>("/api/auth/request-code", {
        method: "POST",
        body: JSON.stringify({ email: form.email }),
      });
      setMessage(response.message);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Could not send code");
    }
  }

  async function verifyCode(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    try {
      const response = await apiRequest<{ user: UserSessionView }>("/api/auth/verify-code", {
        method: "POST",
        body: JSON.stringify(form),
      });
      await onLogin(response.user);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Invalid or expired code");
    }
  }

  return (
    <main className="login-layout">
      <section className="panel login-panel">
        <h1>Crewnovator</h1>
        <p className="muted">Use your email and 6-digit login code to sign in.</p>
        <form className="stack" onSubmit={verifyCode}>
          <label>
            Email
            <input value={form.email} onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))} />
          </label>
          <label>
            6-digit code
            <input value={form.code} inputMode="numeric" maxLength={6} onChange={(event) => setForm((current) => ({ ...current, code: event.target.value.replace(/\D/g, "").slice(0, 6) }))} />
          </label>
          <button type="submit">Sign In With Code</button>
          <button type="button" className="ghost" onClick={() => void requestCode()}>Resend Code</button>
          <button type="button" className="ghost" onClick={onBackToPassword}>Back to Password Login</button>
        </form>
        {message ? <p className="success-banner">{message}</p> : null}
        {error ? <p className="error-banner">{error}</p> : null}
      </section>
    </main>
  );
}
